<template>
  <div class="preview-letter-page">
    <h2>{{ $t('W2P_UPLOAD_MATERIAL_PAGE_TITLE') }}</h2>
    <preview-material-component
      :controls="['scale', 'pagination', 'delete']"
      :showWarnings="true"
      @loading="handleLoading"
    ></preview-material-component>
    <div class="custom-checkbox-container">
      <pn-checkbox-container
        :label="$t('W2P_APPROVE_FOR_PRINTING')"
        @keydown.enter="approvePrinting = !approvePrinting"
        :aria-checked="approvePrinting ? 'true' : 'false'"
        @checkchange="checkBoxChange"
      >
        <input type="checkbox" name="approvePrinting" />
      </pn-checkbox-container>

      <pn-icon
        symbol="alert-exclamation-circle"
        size="medium"
        color="orange700"
        solid
        v-if="getResultWarnings.length"
      ></pn-icon>
    </div>

    <div class="terms">
      <p class="small">
        {{ $t('W2P_LETTER_PDFPREVIEW_TERMS') }}
      </p>
    </div>

    <div class="button-container">
      <pn-button-container secondary size="medium">
        <button @click="back">{{ $t('W2P_LETTER_BACK') }}</button>
      </pn-button-container>

      <pn-button-container size="medium">
        <button
          :disabled="!approvePrinting || loadingPreview"
          @click="$router.push('/letter/address')"
          class="next"
        >
          {{ $t('W2P_LETTER_NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import PreviewMaterialComponent from '@/components/PreviewMaterialComponent'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    PreviewMaterialComponent
  },
  data() {
    return {
      loadingPreview: true
    }
  },
  computed: {
    ...mapState({
      upload: state => state.letter.upload
    }),
    ...mapGetters('letter/upload', ['getResultWarnings']),
    approvePrinting: {
      get() {
        return this.upload.approvePrinting
      },
      set() {
        this.toogleApproveMaterial()
      }
    }
  },
  mounted() {
    sessionStorage.removeItem('orderPlaced')
    if (this.upload && !this.upload.valid) {
      this.$router.push('/letter/upload/upload-letter')
    }
  },
  methods: {
    ...mapMutations({
      toogleApproveMaterial(commit, payload) {
        return commit('letter/upload/TOOGLE_MATERIAL_APPROVE_PRINTING', payload)
      }
    }),
    handleLoading(e) {
      this.loadingPreview = e
    },
    back() {
      this.$router.push('/letter/upload')
    },
    checkBoxChange(e) {
      this.approvePrinting = e.detail
    }
  }
}
</script>

<style lang="scss" scoped>
.terms {
  padding-top: 1em;
  p {
    color: $gray700;
  }
}
</style>
